import React, { useEffect, useContext } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { UserContext } from '../context/UserContext';
import { getActiveRole, getSessionRole, setActiveRole, setAuthToken } from '../utils/authStorage';
import './SamlCallback.css';

const SamlCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setUserData } = useContext(UserContext);

  useEffect(() => {
    const processCallback = async () => {
      const token = searchParams.get('token');
      const error = searchParams.get('error');
      
      
      if (error) {
        console.error('SAML authentication error:', error);
        
        // Redirect to login with error parameter
        navigate(`/login?error=${error}`);
        return;
      }

      if (token) {
        try {
          // Decode token to get user info
          const decoded = jwtDecode(token);
          
          let requiresRoleSelection = false;
          let activeRole = getActiveRole();
          const isDualRole = decoded.isAdmin && decoded.isSzakfelelos;

          if (isDualRole) {
            activeRole = getSessionRole();

            if (!activeRole) {
              requiresRoleSelection = true;
              localStorage.removeItem('activeRole');
            }
          } else if (!activeRole) {
            if (decoded.isAdmin || decoded.isSuperUser) {
              activeRole = 'admin';
            } else if (decoded.isSzakfelelos) {
              activeRole = 'szakfelelos';
            }

            if (activeRole) {
              setActiveRole(activeRole, true);
            }
          }

          // Set user data in context
          setUserData({
            name: decoded.name,
            neptun: decoded.neptun || decoded.neptunCode,
            token: token,
            isSuperUser: decoded.isSuperUser,
            isAdmin: decoded.isAdmin,
            isSzakfelelos: decoded.isSzakfelelos,
            role: activeRole,
            requiresRoleSelection
          });

          // Store only access token in localStorage
          setAuthToken(token);
          
          console.log('SAML authentication successful, access token stored');
          
          if (requiresRoleSelection) {
            navigate('/choose-role');
          } else {
            navigate('/');
          }
        } catch (err) {
          console.error('Error processing token:', err);
          navigate('/login?error=saml_processing_error');
        }
      } else {
        console.error('Missing token in callback');
        navigate('/login?error=missing_tokens');
      }
    };

    processCallback();
  }, [searchParams, navigate, setUserData]);

  return (
    <div className="saml-callback-container">
      <div className="saml-callback-box">
        <div className="spinner"></div>
        <h2>Bejelentkezés...</h2>
        <p>Kérem várjon, amíg befejezzük a bejelentkezést.</p>
      </div>
    </div>
  );
};

export default SamlCallback;
